import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {AgendaCategory} from '../entity/agendaCategory.model';
import {EntityLinkedToAccountWithAuditMetadataConverter} from '../../../../../common/converter/entityLinkedToAccountWithAuditMetadata.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {
    OnlineFormFormDefinitionSummaryConverter
} from '../../../../../online-form/definition/api/entity/converter/onlineFormFormDefinitionSummary.converter';
import {AgendaCategorySummaryConverter} from "./agendaCategorySummary.converter";

@Injectable({
    providedIn: 'root'
})
export class AgendaCategoryConverter extends HttpModelConverter<AgendaCategory> {

    constructor(private onlineFormFormDefinitionSummaryConverter: OnlineFormFormDefinitionSummaryConverter,
                private entityLinkedToAccountWithAuditMetadataConverter: EntityLinkedToAccountWithAuditMetadataConverter,
                private summaryConverter: AgendaCategorySummaryConverter) {
        super();
    }
    protected createInstance(): AgendaCategory {
        return new AgendaCategory();
    }


    protected enrichObject(result: AgendaCategory, src: AgendaCategory) {
        this.entityLinkedToAccountWithAuditMetadataConverter.convert(result, src);
        result.summary = this.summaryConverter.convert(src.summary);
        result.type = new LovValueSummaryConverter().convert(src.type);
        result.onlineFormDefinition = this.onlineFormFormDefinitionSummaryConverter.convert(src.onlineFormDefinition);
    }
}
